var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpecialOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4 12.798H17.6v-4.8h12.8v4.8zm-12.8 16h9.6v-14.4h-9.6v14.4zm-.8-23.709c-.088-.536 2.782-2.19 6.94-3.045 1.727-.355 2.762-.457 3.382-.457.606 0 .812.097.876.158.07.362-.9 1.714-2.379 2.837-.878.667-2.347 1.784-4.574 1.816-2.175.066-4.17-.86-4.245-1.309zm-1.6 0c-.075.448-2.136 1.376-4.245 1.309-2.227-.032-3.696-1.149-4.574-1.816-1.479-1.123-2.448-2.475-2.399-2.805.075-.077.295-.187.93-.187.627 0 1.654.107 3.347.454 4.159.855 7.029 2.51 6.94 3.045zm-.8 7.709H1.6v-4.8h12.8v4.8zm-9.6 16h9.6v-14.4H4.8v14.4zm26.4-22.4h-5.36c.286-.197.54-.386.747-.542.288-.22 2.811-2.183 3-3.888.053-.468-.069-.89-.35-1.224-.971-1.15-3.512-.741-5.818-.268C23.141.534 18 1.62 16 3.546 14 1.62 8.86.533 8.58.475 6.279.003 3.737-.407 2.764.746c-.281.332-.403.754-.35 1.222.189 1.705 2.712 3.668 3 3.888.206.156.46.345.747.542H.8a.8.8 0 00-.8.8v6.4a.8.8 0 00.8.8h2.4v15.2a.8.8 0 00.8.8h24a.8.8 0 00.8-.8v-15.2h2.4a.8.8 0 00.8-.8v-6.4a.8.8 0 00-.8-.8z",
    fill: "#000"
  })));
}

SvgSpecialOffer.displayName = 'SpecialOffer';
export default SvgSpecialOffer;